import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy, memo } from 'react';

const LazyStudentLesson = lazy(() =>
  import('./StudentLesson')
    .then((module) => ({ default: module.StudentLesson }))
    .catch(() => {
      document.location.reload();
      return { default: memo(() => <></>) };
    })
);

export const StudentLesson = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyStudentLesson />
  </Suspense>
);
